export default __webpack_public_path__ + "static/media/hero-wwII-1440x600-2.3774fd72.jpg";